import { Injectable } from '@angular/core';
import axios, { AxiosError } from 'axios';
import { environment } from 'src/environments/environment';
import { CaseTableItem, Product } from './types';

const COFACE_PRODUCT_TYPE: Product = 'coface';

type CofaceCaseStatusResponse = {
  case: CaseTableItem;
};

@Injectable({
  providedIn: 'root',
})
export class CofaceCasesService {
  private readonly loadingCaseIds = new Set<string>();

  isCofaceStatusLoading(caseId: string): boolean {
    return this.loadingCaseIds.has(caseId);
  }

  async refreshCofaceStatusIfNeeded(item: CaseTableItem): Promise<void> {
    if (
      item.product_type !== COFACE_PRODUCT_TYPE
      || this.loadingCaseIds.has(item.id)
      || !item.coface_expired
    ) {
      return;
    }

    this.loadingCaseIds.add(item.id);

    try {
      const url = `${environment.baseUrl}/api/case/${item.id}/coface-case-status`;
      const res = await axios.get<CofaceCaseStatusResponse>(url);
      if (res.data.case) {
        Object.assign(item, res.data.case);
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.status === 422) {
        return;
      }
      console.error('Failed to refresh Coface case status', error);
    } finally {
      this.loadingCaseIds.delete(item.id);
    }
  }
}
